import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null); // null = checking, false = logged out, object = logged in
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const { data } = await api.get("/auth/me");
                if (!cancelled) setUser(data);
            } catch (error) {
                // 401 expected for guests — only log unexpected errors
                if (error?.response && error.response.status !== 401) {
                    console.error("Auth check failed:", error);
                }
                if (!cancelled) setUser(false);
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    const value = useMemo(() => {
        const login = async (email, password) => {
            const { data } = await api.post("/auth/login", { email, password });
            setUser(data.user);
            return data.user;
        };

        const logout = async () => {
            try {
                await api.post("/auth/logout");
            } catch (error) {
                console.error("Logout request failed:", error);
            }
            setUser(false);
        };

        return { user, loading, login, logout };
    }, [user, loading]);

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
